namespace Cfnc {
    /** Enum that represents the available comparison operations for Campus Search Filters. */
    export enum CompareOperator {
        /** The < operator */
        LessThan,
        /** The <= operator */
        LessThanEqualTo,
        /** The = operator */
        Equal,
        /** The > operator */
        GreaterThan,
        /** The >= operator */
        GreaterThanEqualTo,
        /** The != operator */
        NotEqual,
        /** The contains operator. Use with strings only. */
        StartsWith,
        /** The does not contain operator. Use with strings only. */
        DoesNotStartWith,
        In,
        NotIn,
        WithInRadiusOf,
    }
} 